module.exports = __webpack_public_path__ + "img/icon-document.6bf66045.svg";